import { useState } from "react";
import ReactGA from "react-ga4";
import { Helmet } from "react-helmet";

// Firebase
import { signInWithEmailAndPassword } from "firebase/auth";

// Form helper
import { escapedEntry } from "src/components/organisms/loginPage/loginPageHelpers";

const LoginPage = ({ auth }: any) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    ReactGA.event({
      category: "Auth",
      action: "Login submitted",
    });

    // basic validation check
    if (!username || !password) {
      setError("Both fields are required.");
      ReactGA.event({
        category: "Auth",
        action: "Login failed",
        label: "validation",
      });
      return;
    }

    // reset any errors
    setError("");

    // sign in to Firebase
    signInWithEmailAndPassword(
      auth,
      escapedEntry(username),
      escapedEntry(password)
    ).catch((error) => {
      setError(error.message);
      ReactGA.event({
        category: "Auth",
        action: "Login failed",
        label: error.code || "firebase_auth_error",
      });
    });
  };

  return (
    <div className="container container--page">
      <Helmet>
        <title>Login | Recipe Finder</title>
        <meta
          name="description"
          content="Log in to Recipe Finder to access and manage your saved recipes."
        />
      </Helmet>

      <h1>Login</h1>

      {error && <p>{error}</p>}
      <form onSubmit={handleSubmit}>
        <div>
          <label htmlFor="username">Email:</label>
          <input
            type="text"
            id="username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />
        </div>
        <div>
          <label htmlFor="password">Password:</label>
          <input
            type="password"
            id="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>
        <button type="submit">Login</button>
      </form>
    </div>
  );
};

export default LoginPage;
